import styled, { css } from 'styled-components';
import { StyledInputProps } from './types';

export const inputCommonStyle = css<StyledInputProps>`
  background: ${({ theme }) => theme.color.background.neutral.default};
  border-width: ${({ theme }) => theme.border.width.thinner};
  border-style: ${({ theme }) => theme.border.style.solid};
  border-radius: ${({ theme }) => theme.border.radius.medium};
  padding: ${({ theme }) => theme.spacing.km0}
    ${({ theme }) => theme.spacing.km3};
  font-size: ${({ theme }) => theme.font.size.m3};
  width: ${({ $width }) => $width};
  height: 48px;

  ${({ $variant = 'default' }) =>
    $variant === 'default' &&
    css`
      background: ${({ theme }) => theme.color.background.neutral.default};
      border-color: ${({ theme }) => theme.color.border.neutral.default};
    `}

  ${({ $variant }) =>
    $variant === 'filled' &&
    css`
      background: ${({ theme }) => theme.color.background.neutral.default};
      border-color: ${({ theme }) => theme.color.border.neutral.strong};
    `}

  ${({ $variant }) =>
    $variant === 'success' &&
    css`
      background: ${({ theme }) => theme.color.background.neutral.default};
      border-color: ${({ theme }) => theme.color.border.success.default};
    `}

  ${({ $variant }) =>
    $variant === 'error' &&
    css`
      background: ${({ theme }) => theme.color.background.neutral.default};
      border-color: #e7236a;
    `}

  &:focus {
    background: ${({ theme }) => theme.color.background.neutral.weak};
    border-color: ${({ theme }) => theme.color.border.neutral.strong};
  }

  &:disabled {
    background: ${({ theme }) => theme.color.background.neutral.weak};
    border-color: #dddfe4;
    color: ${({ theme }) => theme.color.text.neutral.weak};
  }

  ::placeholder {
    color: ${({ theme }) => theme.color.text.neutral.weak};
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    width: 100%;
  }
`;

export const Input = styled.input<StyledInputProps>`
  ${inputCommonStyle}

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  [type='number'] {
    -moz-appearance: textfield;
  }
`;
